<template>
  <span ref="numberGrow" :value="value" :data-time="time" class="number-grow" :data-value="value">{{ sum }}</span>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {
      time: 0.5,
      sum: 0
    }
  },
  watch: {
    value() {
      console.log('this.value', this.value)

      if (this.value > 0) {
        this.numberGrow(this.$refs.numberGrow)
        console.log(this.sum)
      }
    }
  },
  mounted() {
    if (this.value > 0) {
      this.numberGrow(this.$refs.numberGrow)
    }
  },
  methods: {
    numberGrow(ele) {
      let _this = this
      console.log('_this.value', _this.value)
      let step = ((_this.value * 10) / (_this.time * 1000)).toFixed(0)
      console.log('step', step)
      let current = 0
      let start = 0
      let t = setInterval(function () {
        start += Number(step)
        if (start > _this.value) {
          clearInterval(t)
          start = _this.value
          t = null
        }
        if (current === start) {
          _this.sum = _this.value.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
          return
        }
        current = start
        _this.sum = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
        // ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
      }, 10)
    },
  }

}

</script>

<style scoped="scoped">
.number-grow-warp {
  transform: translateZ(0);
}
</style>



// WEBPACK FOOTER //
// src/components/Operational_data/views/sumAnimation.vue